import React from "react";
import { Link } from "react-router-dom";
import { ExternalLink } from "lucide-react";

const JBH_PRIVACY = "https://jamesbassholding.com/legal.html#privacy-policy";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 mt-auto">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 pt-8">
        <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-sm pb-6 border-b border-white/5">
          <span className="text-slate-300 font-semibold">Find work:</span>
          <Link to="/work/jobs/netherlands" className="text-slate-400 hover:text-teal-300">Netherlands</Link>
          <Link to="/work/jobs/amsterdam" className="text-slate-400 hover:text-teal-300">Amsterdam</Link>
          <Link to="/work/jobs/rotterdam" className="text-slate-400 hover:text-teal-300">Rotterdam</Link>
          <Link to="/work/jobs/warehouse-jobs" className="text-slate-400 hover:text-teal-300">Warehouse</Link>
          <Link to="/work/jobs/production-jobs" className="text-slate-400 hover:text-teal-300">Production</Link>
          <Link to="/work/jobs/driver-jobs" className="text-slate-400 hover:text-teal-300">Driver</Link>
          <Link to="/work/live-in-netherlands" className="text-slate-400 hover:text-teal-300">Live &amp; work in NL</Link>
          <Link to="/work/jobs" className="text-teal-300 hover:text-teal-200 font-medium">All jobs →</Link>
        </div>
      </div>
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-8 flex flex-col gap-5 md:flex-row md:items-center md:justify-between">
        <div className="text-sm text-slate-500">
          <span className="font-mono text-slate-400">WorkOnIT</span> — Jobs · Careers · Employment
          <p className="mt-1.5 text-xs text-slate-600 max-w-md leading-relaxed">
            WorkOnIT is a directory and platform — not an employment agency. Managed by WorkOnIT and owned by
            JamesBass Technologies, Los Angeles, California (a division of JamesBass Holding LLC).
          </p>
        </div>
        <nav className="flex flex-wrap items-center gap-x-5 gap-y-2 text-sm">
          <Link to="/legal#disclaimer" data-testid="footer-link-about" className="text-slate-400 hover:text-teal-300 transition-colors">About the platform</Link>
          <Link to="/legal#terms" data-testid="footer-link-terms" className="text-slate-400 hover:text-teal-300 transition-colors">Terms of Use</Link>
          <Link to="/legal#privacy" data-testid="footer-link-privacy" className="text-slate-400 hover:text-teal-300 transition-colors">Privacy Policy</Link>
          <Link to="/legal#gdpr" data-testid="footer-link-gdpr" className="text-slate-400 hover:text-teal-300 transition-colors">GDPR</Link>
          <a href={JBH_PRIVACY} target="_blank" rel="noopener noreferrer" data-testid="footer-link-jbh"
            className="inline-flex items-center gap-1 text-cyan-400 hover:text-cyan-300 transition-colors">
            Corporate policy <ExternalLink size={12} />
          </a>
        </nav>
      </div>
      <div className="border-t border-white/5 py-4 text-center text-xs text-slate-600">
        © {year} JamesBass Holding LLC. All rights reserved.
      </div>
    </footer>
  );
}
